import { combineReducers } from '@reduxjs/toolkit';
import sideMenuFiltersReducers from './sideMenuFilters';
import dashboardFiltersReducers from './dashboardFilters';

const filterReducers = combineReducers({
  menu: sideMenuFiltersReducers,
  dashboard: dashboardFiltersReducers
});

export default filterReducers;
